import { defaultClient as apolloClient } from "../../../main";
import { FETCH_PACKAGE_DATES_PRICING, UPDATE_PACKAGE_DATE_PRICING } from "../../../queries/packages.queries";
import moment from "moment-timezone";
const state = {
  isPkgDatesLoading: false,
  pkgDatesDetails: null,
  forexPricing: {
    price_model: "",
    currency: "",
    benchmark: {
      source: "",
      captured_on: moment().format("YYYY-MM-DD"),
      rates: ""
    },
    pricing: [
      { type: "Adult Single", key: "adult_single", fx: "", amount: "" },
      { type: "Adult Twin", key: "adult_twin", fx: "", amount: "" },
      { type: "Adult Triple", key: "adult_triple", fx: "", amount: "" },
      { type: "CWB", key: "child_cwb", fx: "", amount: "" },
      { type: "CNB", key: "child_cnb", fx: "", amount: "" },
      { type: "CNB2", key: "child_cnb2", fx: "", amount: "" },
      { type: "Infant", key: "infant", fx: "", amount: "" }
    ]
  },
  datesPricing: {
    adult: {
      single: "",
      singleallowed: true,
      twin: "",
      twinallowed: true,
      extrabed: "",
      extrabedallowed: true,
      surcharge: ""
    },
    child: {
      cwballowed: true,
      cwb: "",
      cwbsurcharge: "",
      cnballowed: true,
      cnb: "",
      cnbsurcharge: "",
      cnb2allowed: true,
      cnb2: "",
      cnb2surcharge: ""
    },
    "surcharge-description": "",
    infant: "",
    infantallowed: true
  }
};

const mutations = {
  setPackageDateLoading(state, value) {
    state.isPkgDatesLoading = value;
  },
  setPackageDateDetails(state, value) {
    state.pkgDatesDetails = value;
  }
};

const actions = {
  fetchPackageDatesPricing: ({ commit }, code) => {
    commit("setPackageDateLoading", true);
    commit("setPackageDateDetails", null);
    return new Promise((resolve, reject) => {
      apolloClient
        .query({
          query: FETCH_PACKAGE_DATES_PRICING,
          variables: { code }
        })
        .then(({ data }) => {
          resolve(data.fetchAvailableDates);
          commit("setPackageDateLoading", false);
          commit("setPackageDateDetails", data.fetchAvailableDates);
        })
        .catch((err) => {
          commit("setPackageDateLoading", false);
          reject(err);
        });
    });
  },
  updatePackageDatesPricing: (_, payload) => {
    return new Promise((resolve, reject) => {
      apolloClient
        .mutate({
          mutation: UPDATE_PACKAGE_DATE_PRICING,
          variables: { payload }
        })
        .then(({ data }) => {
          resolve(data.insertAndUpdateDates);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }
};

const getters = {
  isPkgDatesLoading: (state) => state.isPkgDatesLoading,
  pkgDatesDetails: (state) => state.pkgDatesDetails,
  datesPricing: (state) => state.datesPricing,
  forexPricing: (state) => state.forexPricing
};

export default {
  state,
  mutations,
  actions,
  getters
};
